<template>
    <section>
        <!--工具条-->
        <BusLineShiftTimeToolbar :buttonList="buttonList" @callFunction="callFunction"></BusLineShiftTimeToolbar>

        <!--列表-->
        <el-table :data="busLineShiftTimes" highlight-current-row v-loading="listLoading" @current-change="selectCurrentRow"
            style="width: 100%;">
            <el-table-column fixed="left" type="index" label="序号" width="80"></el-table-column>
            <el-table-column fixed="left" label="操作" width="80">
                <template slot-scope="scope">
                    <span v-for="item in operationButtonList" :key="item.id">
                        <el-button type="text" style="padding-right:6px;" size="small" v-if="!item.IsHide"
                            @click="operationButtonFunction(item, scope.row)">{{ item.name }}</el-button>
                    </span>
                </template>
            </el-table-column>
            <el-table-column fixed="left" prop="LineChineseName" label="公交线路中文名称" width="200" sortable></el-table-column>
            <el-table-column prop="BusLineDirectionChineseName" label="公交线路方向中文名称" width="200" sortable></el-table-column>
            <el-table-column prop="FirstShiftTime" label="首班时间" width="200" sortable></el-table-column>
            <el-table-column prop="LastShiftTime" label="末班时间" width="200" sortable></el-table-column>
        </el-table>

        <!--工具条-->
        <el-col :span="24" class="toolbar">
            <el-pagination layout="total, sizes, prev, pager, next" @size-change="handleSizeChange"
                @current-change="handleCurrentChange" :current-page.sync="page" :page-sizes="[10, 15, 20, 50, 100, 200]"
                :total="total" style="float:right;"></el-pagination>
        </el-col>

        <!--编辑界面-->
        <el-dialog title="编辑" :visible.sync="editFormVisible" v-model="editFormVisible" width="65%"
            :close-on-click-modal="false">
            <el-form :model="editForm" label-width="80px" :rules="editFormRules" ref="editForm">
                <el-row>
                    <el-col :span="10">
                        <el-form-item label="公交线路" prop="BusLinesId" label-width="110px">
                            <el-select style="width: 100%;" @change="selectChanged" v-model="editForm.BusLinesId"
                                placeholder="请选择公交线路">
                                <el-option v-for="item in busLiness" :key="item.Id" :value="item.Id"
                                    :label="item.LineChineseName">
                                    <span style="float: left">{{ item.LineChineseName }}</span>
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="10">
                        <el-form-item label="线路方向" prop="BusLineDirectionChineseName" label-width="110px">
                            <el-select style="width: 100%;" v-model="editForm.BusLineDirectionChineseName" clearable
                                placeholder="请选择线路方向">
                                <el-option v-for="item in sites" :key="item.Id" :value="item.BusLineDirectionChineseName"
                                    :label="item.BusLineDirectionChineseName">
                                    <span style="float: left">{{ item.BusLineDirectionChineseName }}</span>
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="10">
                        <el-form-item label="首班时间" prop="FirstShiftTime" label-width="110px">
                            <el-time-picker v-model="editForm.FirstShiftTime" value-format="HH:mm" format="HH:mm"
                                style="width:187px">
                            </el-time-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="10">
                        <el-form-item label=" 末班时间" prop="LastShiftTime" label-width="110px">
                            <el-time-picker v-model="editForm.LastShiftTime" value-format="HH:mm" format="HH:mm"
                                style="width:187px">
                            </el-time-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="editFormVisible = false">取消</el-button>
                <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
            </div>
        </el-dialog>

        <!--新增界面-->
        <el-dialog title="新增" :visible.sync="addFormVisible" v-model="addFormVisible" width="65%"
            :close-on-click-modal="false">
            <el-form :model="addForm" label-width="80px" :rules="addFormRules" ref="addForm">
                <el-row>
                    <el-col :span="10">
                        <el-form-item label="公交线路" prop="BusLinesId" label-width="110px">
                            <el-select style="width: 100%;" @change="selectChanged" v-model="addForm.BusLinesId"
                                placeholder="请选择公交线路">
                                <el-option v-for="item in busLiness" :key="item.Id" :value="item.Id"
                                    :label="item.LineChineseName">
                                    <span style="float: left">{{ item.LineChineseName }}</span>
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="10">
                        <el-form-item label="线路方向" prop="BusLineDirectionChineseName" label-width="110px">
                            <el-select style="width: 100%;" v-model="addForm.BusLineDirectionChineseName" clearable
                                placeholder="请选择线路方向">
                                <el-option v-for="item in sites" :key="item.Id" :value="item.BusLineDirectionChineseName"
                                    :label="item.BusLineDirectionChineseName">
                                    <span style="float: left">{{ item.BusLineDirectionChineseName }}</span>
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="10">
                        <el-form-item label="首班时间" prop="FirstShiftTime" label-width="110px">
                            <el-time-picker v-model="addForm.FirstShiftTime" value-format="HH:mm" format="HH:mm"
                                style="width:187px">
                            </el-time-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="10">
                        <el-form-item label=" 末班时间" prop="LastShiftTime" label-width="110px">
                            <el-time-picker v-model="addForm.LastShiftTime" value-format="HH:mm" format="HH:mm"
                                style="width:187px">
                            </el-time-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="addFormVisible = false">取消</el-button>
                <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
            </div>
        </el-dialog>

        <!--操作日记-->
        <el-dialog title="操作日记" :visible.sync="operateDataLogFormVisible" v-model="operateDataLogFormVisible"
            :close-on-click-modal="false" :destroy-on-close="true" width="60%">
            <OperateDataLog v-if="operateDataLogFormVisible" :entityName="entityName" :entityKey="entityKey">
            </OperateDataLog>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="operateDataLogFormVisible = false">关闭</el-button>
            </div>
        </el-dialog>
    </section>
</template>
  
<script>
import util from "../../../util/date";
import { getBusLinesListPage, getBusLineDirectionByBusLinesId, getBusLineShiftTimePage, removeBusLineShiftTime, editBusLineShiftTime, addBusLineShiftTime, baiduTrans, importSiteDataUrl, SaveExcel } from "../../api/api";
import { getButtonList, getOperationButtonList } from "../../promissionRouter";
import BusLineShiftTimeToolbar from "../../components/QueryToolbar/BusLineShiftTimeToolbar";
import OperateDataLog from "../../components/OperateDataLog";
import ImportExcel from "../Upload/ImportExcel";

export default {
    components: {
        BusLineShiftTimeToolbar,
        OperateDataLog,
        ImportExcel
    },
    data() {
        return {
            filters: {
                busLinesId: ""
            },
            entityName: 'BusLineShiftTime', //操作日记中的表名称
            entityKey: '',  //操作日记中的表的Id
            buttonList: [],
            action: '',
            operationButtonList: [],
            busLineShiftTimes: [], //公交线路班车时间列表
            busLiness: [], //线路列表
            sites: [], //站点列表
            total: 0,
            page: 1,
            pageSize: 10,
            listLoading: false,
            sels: [], //列表选中列
            currentRow: null,
            addDialogFormVisible: false,
            operateDataLogFormVisible: false, //查看操作日记界面是否显示
            importExcelFormVisible: false, //导入页面是否显示
            editFormVisible: false, //编辑界面是否显示
            editLoading: false,
            editFormRules: {
                BusLinesId: [{ required: true, message: "请输入公交线路", trigger: "blur" }],
                BusLineDirectionChineseName: [{ required: true, message: "请输入线路中文名称", trigger: "blur" }],
                FirstShiftTime: [{ required: true, message: "请输入首班时间", trigger: "blur" }],
                LastShiftTime: [{ required: true, message: "请输入末班时间", trigger: "blur" }],
            },
            //编辑界面数据
            editForm: {
                Id: 0,
                CreateBy: "",
                BusLinesId: 0,
                BusLineDirectionChineseName: "",
                FirstShiftTime: "",
                LastShiftTime: ""
            },
            addFormVisible: false, //新增界面是否显示
            addLoading: false,
            addFormRules: {
                BusLinesId: [{ required: true, message: "请输入公交线路", trigger: "blur" }],
                BusLineDirectionChineseName: [{ required: true, message: "请输入线路中文名称", trigger: "blur" }],
                FirstShiftTime: [{ required: true, message: "请输入首班时间", trigger: "blur" }],
                LastShiftTime: [{ required: true, message: "请输入末班时间", trigger: "blur" }],
            },
            //新增界面数据
            addForm: {
                CreateBy: "",
                CreateId: "",
                BusLinesId: 0,
                BusLineDirectionChineseName: "",
                FirstShiftTime: "",
                LastShiftTime: ""
            }
        };
    },
    methods: {
        selectCurrentRow(val) {
            this.currentRow = val;
        },
        callFunction(item) {
            this.filters = {
                busLinesId: item.busLinesId
            };
            this[item.Func].apply(this, item);
        },
        operationButtonFunction(item, row) {
            this.currentRow = row;
            this[item.Func].apply(this, item);
        },
        handleSizeChange(val) {
            this.page = 1;
            this.pageSize = val;
            this.getBusLineShiftTime();
        },
        handleCurrentChange(val) {
            this.page = val;
            this.getBusLineShiftTime();
        },
        queryBusLineShiftTime() {
            this.page = 1;
            this.getBusLineShiftTime();
        },
        //获取线路列表
        getBusLineShiftTime() {
            let _this = this;
            let para = {
                page: _this.page,
                pageSize: _this.pageSize,
                busLinesId: _this.filters.busLinesId
            };
            _this.listLoading = true;
            getBusLineShiftTimePage(para).then(res => {
                _this.total = res.data.response.dataCount;
                _this.busLineShiftTimes = res.data.response.data;
                _this.listLoading = false;
            });
        },
        //删除
        handleDel() {
            let row = this.currentRow;
            if (!row) {
                this.$message({
                    message: "请选择要编辑的一行数据！",
                    type: "error"
                });

                return;
            }
            this.$confirm("确认删除该记录吗?", "提示", {
                type: "warning"
            })
                .then(() => {
                    this.listLoading = true;
                    let para = { id: row.Id };
                    removeBusLineShiftTime(para).then(res => {
                        if (util.isEmt.format(res)) {
                            this.listLoading = false;
                            return;
                        }
                        this.listLoading = false;
                        if (res.data.success) {
                            this.$message({
                                message: "删除成功",
                                type: "success"
                            });
                        } else {
                            this.$message({
                                message: res.data.msg,
                                type: "error"
                            });
                        }

                        this.getBusLineShiftTime();
                    });
                })
                .catch(() => { });
        },
        //显示编辑界面
        handleEdit() {
            let row = this.currentRow;
            if (!row) {
                this.$message({
                    message: "请选择要编辑的一行数据！",
                    type: "error"
                });

                return;
            }

            this.editFormVisible = true;
            this.editForm = Object.assign({}, row);
        },
        //显示新增界面
        handleAdd() {
            this.addFormVisible = true;
            this.addForm = {
                CreateBy: "",
                Enabled: "true"
            };
        },
        //查看操作日记
        lookUpOperateDataLog() {
            this.operateDataLogFormVisible = true;
            this.entityKey = this.currentRow.Id;
        },
        //编辑
        editSubmit: function () {
            this.$refs.editForm.validate(valid => {
                if (valid) {
                    this.$confirm("确认提交吗？", "提示", {}).then(() => {
                        this.editLoading = true;
                        let para = Object.assign({}, this.editForm);

                        para.birth =
                            !para.birth || para.birth == ""
                                ? util.formatDate.format(new Date(), "yyyy-MM-dd")
                                : util.formatDate.format(new Date(para.birth), "yyyy-MM-dd");

                        editBusLineShiftTime(para).then(res => {
                            if (util.isEmt.format(res)) {
                                this.editLoading = false;
                                return;
                            }

                            if (res.data.success) {
                                this.editLoading = false;
                                //NProgress.done();
                                this.$message({
                                    message: res.data.msg,
                                    type: "success"
                                });
                                this.$refs["editForm"].resetFields();
                                this.editFormVisible = false;
                                this.getBusLineShiftTime();
                            } else {
                                this.$message({
                                    message: res.data.msg,
                                    type: "error"
                                });
                            }
                        });
                    });
                }
            });
        },
        //新增
        addSubmit: function () {
            let _this = this;
            this.$refs.addForm.validate(valid => {
                if (valid) {
                    this.$confirm("确认提交吗？", "提示", {}).then(() => {
                        this.addLoading = true;
                        let para = Object.assign({}, this.addForm);
                        para.birth =
                            !para.birth || para.birth == ""
                                ? util.formatDate.format(new Date(), "yyyy-MM-dd")
                                : util.formatDate.format(new Date(para.birth), "yyyy-MM-dd");

                        var user = JSON.parse(window.localStorage.user);

                        if (user && user.uID > 0) {
                            para.CreateId = user.uID;
                            para.CreateBy = user.uRealName;
                        } else {
                            this.$message({
                                message: "用户信息为空，先登录",
                                type: "error"
                            });
                            _this.$router.replace(
                                _this.$route.query.redirect ? _this.$route.query.redirect : "/"
                            );
                        }

                        addBusLineShiftTime(para).then(res => {
                            if (util.isEmt.format(res)) {
                                this.addLoading = false;
                                return;
                            }
                            if (res.data.success) {
                                this.addLoading = false;
                                this.$message({
                                    message: res.data.msg,
                                    type: "success"
                                });
                                this.$refs["addForm"].resetFields();
                                this.addFormVisible = false;
                                this.getBusLineShiftTime();
                            } else {
                                this.$message({
                                    message: res.data.msg,
                                    type: "error"
                                });
                            }
                        });
                    });
                }
            });
        },
        selsChange: function (sels) {
            this.sels = sels;
        },
        //批量删除
        batchRemove: function () {
            this.$message({
                message: "该功能未开放",
                type: "warning"
            });
        },
        getButtonList2(routers) {
            let _this = this;
            routers.forEach(element => {
                let path = this.$route.path.toLowerCase();
                if (element.path && element.path.toLowerCase() == path) {
                    _this.buttonList = element.children;
                    return;
                } else if (element.children) {
                    _this.getButtonList(element.children);
                }
            });
        },
        selectChanged(value) {
            this.sites = [];
            this.BusLineDirectionChineseName = "";
            if (value !== "")
                this.getBusLineDirection(value);
        },
        getBusLineDirection(value) {
            let para = {
                busLinesId: value
            };
            getBusLineDirectionByBusLinesId(para).then(res => {
                this.sites = res.data.data;
            });
        }
    },
    mounted() {
        this.getBusLineShiftTime();

        let pageSizePara = {
            pageSize: 100
        };
        getBusLinesListPage(pageSizePara).then(res => {
            this.busLiness = res.data.response.data;
        });

        let routers = window.localStorage.router
            ? JSON.parse(window.localStorage.router)
            : [];
        //第一种写法，每个页面都需要写方法，但是可以做特性化处理
        // this.getButtonList(routers);

        //第二种写法，封装到 permissionRouter.js 中
        this.buttonList = getButtonList(this.$route.path, routers);
        this.operationButtonList = getOperationButtonList(this.$route.path, routers);
    }
}
</script>
  
<style scoped></style>
  